<template>
    <div class="flex flex-wrap justify-center">
        <div v-for="service in services" class="w-full md:w-1/2 lg:w-1/3">
            <services-card-component :service="service" ></services-card-component>
        </div>
    </div>
</template>

<script>
import ServicesCardComponent from './ServicesCardComponent.vue';
export default {
    components: {
        ServicesCardComponent
    },

    data() {
        return {
            services: [
                {
                    name: "Nettside",
                    description: "En nettside gir bedrifter en enkel nettbasert tilstedeværelse for informasjon og kontakt.",
                    pricesFrom: "7.500",
                    campaigne: {
                        priceFrom: "4500",
                        message: "Tilbudet gjelder kun de 5 første kundene og må aksepteres innen 30. Juni 2025."
                    },
                    includes: [
                        'Oppstartsmøte',
                        'Nettside laget med WordPress',
                        'Moderne design',
                        'Tilrettelegging for SEO',
                        'Kontaktskjema',
                        'Forside, tjenester, referanser, om oss, kontakt oss'
                
                    ]
                },
                {
                    name: "Mobil-applikasjon",
                    description: "Skreddersydde mobilapper hjelper bedrifter med kundeservice, effektivisering og bedre brukeropplevelse.",
                    pricesFrom: "10.000",
                    includes: [
                        'Oppstartsmøte',
                        'Skreddersydd innhold og applikasjon etter ønske og behov',
                        'Lansering i Google Play Store / Apple Store'
                    ]
                },
                {
                    name: "Web-applikasjon",
                    description: "Webapplikasjoner gir bedrifter en plattform for tjenester, verktøy og datainnsamling for kunder og ansatte.",
                    pricesFrom: "30.000",
                    includes: [
                        'Oppstartsmøte',
                        'Skreddersydd innhold og applikasjon etter ønske og behov',
                        'Tilrettelegging for SEO',
                        'Lansering av web app'
                    ]
                }
            ]
        }
    }
}
</script>